// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Condition } from './Condition';
import {
  ConditionFromJSON,
  ConditionFromJSONTyped,
  ConditionToJSON,
  ConditionToJSONTyped,
} from './Condition';

/**
 *
 * @export
 * @interface PartitionStatus
 */
export interface PartitionStatus {
  /**
   *
   * @type {Array<Condition>}
   * @memberof PartitionStatus
   */
  conditions?: Array<Condition>;
}

/**
 * Check if a given object implements the PartitionStatus interface.
 */
export function instanceOfPartitionStatus(
  value: object,
): value is PartitionStatus {
  return true;
}

export function PartitionStatusFromJSON(json: any): PartitionStatus {
  return PartitionStatusFromJSONTyped(json, false);
}

export function PartitionStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionStatus {
  if (json == null) {
    return json;
  }
  return {
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionFromJSON),
  };
}

export function PartitionStatusToJSON(json: any): PartitionStatus {
  return PartitionStatusToJSONTyped(json, false);
}

export function PartitionStatusToJSONTyped(
  value?: PartitionStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionToJSON),
  };
}
